import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link, browserHistory } from "react-router";
import AppBar from "material-ui/AppBar";
import IconMenu from "material-ui/IconMenu";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import { blue700, blue600, pinkA200 } from "material-ui/styles/colors";
import ChatIcon from "material-ui/svg-icons/communication/chat";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import AccountCircleIcon from "material-ui/svg-icons/action/account-circle";
import HelpIcon from "material-ui/svg-icons/action/help";
import _ from "lodash";
import { showFaq, setInSearch } from "../../../actions/faq_form";
import { LBLAPP, NameArlTest } from "../../../constants/labels";

import { showModalChangePassword } from "../../ModalChangePassword/actions";
import { logOut } from "./actions";
import ModalChangeFirstPassword from "../../ModalChangePassword/componentChangeFirstPassword";
import ModalChangePassword from "../../ModalChangePassword/componentChangePassword";

class appBarDashboardArl extends Component {
    constructor(props) {
        super(props);
        this._handleLogOut = this._handleLogOut.bind(this);
        this._handleShowModalChangePassword = this._handleShowModalChangePassword.bind(
            this
        );
        this.onTapFaq = this.onTapFaq.bind(this);
    }

    onTapFaq() {
        const { showFaq, setInSearch } = this.props;
        setInSearch();
        showFaq(true);
    }

    _handleShowModalChangePassword() {
        this.props.showModalChangePassword(true);
    }

    _handleLogOut() {
        const { logOut } = this.props;
        logOut();
        browserHistory.push("/login");
    }

    UNSAFE_componentWillMount() {
        const { profile } = this.props;
        const personId = _.get(profile, "person._id");
        if (!personId) {
            console.error("No hay un usuario logeado");
            browserHistory.replace(`/login`);
        }
    }

    render() {
        const { profile, loggedIn } = this.props;
        const firstPassword = _.get(profile, "firstPassword");
        const userName = loggedIn
            ? `${_.get(profile, "person.name")} ${_.get(
                  profile,
                  "person.lastName"
              )}`
            : NameArlTest;
        return (
            <AppBar
                title={LBLAPP.title}
                style={{ zIndex: 1400, position: "fixed", left: 0 }}
                showMenuIconButton={false}
                iconElementRight={
                    <div>
                        <IconButton
                            touch
                            tooltip={LBLAPP.menu.frecuenceQuestions}
                            children={<HelpIcon color="#FFF" />}
                            onClick={this.onTapFaq}
                        />
                        <IconMenu
                            iconButtonElement={
                                <IconButton iconStyle={{ fill: "#FFF" }}>
                                    <MoreVertIcon />
                                </IconButton>
                            }
                            targetOrigin={{
                                horizontal: "right",
                                vertical: "top",
                            }}
                            anchorOrigin={{
                                horizontal: "right",
                                vertical: "top",
                            }}
                        >
                            <MenuItem
                                primaryText={userName}
                                rightIcon={
                                    <AccountCircleIcon color={blue600} />
                                }
                                disabled
                                innerDivStyle={{
                                    paddingBottom: 5,
                                    borderBottom: "1px solid #CCC",
                                }}
                                style={{ color: "#2E2E2E" }}
                            />
                            <MenuItem
                                primaryText="Cambiar contraseña"
                                onClick={this._handleShowModalChangePassword}
                            />
                            <MenuItem
                                onClick={this._handleLogOut}
                                primaryText="Cerrar sesión"
                            />
                        </IconMenu>
                        <ModalChangeFirstPassword
                            showChangePass={firstPassword}
                            user={profile}
                        />
                        <ModalChangePassword user={profile} />
                    </div>
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            logOut,
            showModalChangePassword,
            showFaq,
            setInSearch,
        },
        dispatch
    );
}

function mapStateToProps({ login }) {
    return {
        profile: login.get("profile"),
        loggedIn: login.get("loggedIn"),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(appBarDashboardArl);
